import React from 'react';

const UserSVG = () => {
  return (
    <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.00005 5.40002C6.99416 5.40002 7.80005 4.59414 7.80005 3.60002C7.80005 2.60591 6.99416 1.80002 6.00005 1.80002C5.00594 1.80002 4.20005 2.60591 4.20005 3.60002C4.20005 4.59414 5.00594 5.40002 6.00005 5.40002ZM6.00005 6.80002C7.76736 6.80002 9.20005 5.36734 9.20005 3.60002C9.20005 1.83271 7.76736 0.400024 6.00005 0.400024C4.23274 0.400024 2.80005 1.83271 2.80005 3.60002C2.80005 5.36734 4.23274 6.80002 6.00005 6.80002Z"
        fill="#969FA8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.3 11.2685L10.3 11.2667C10.3 11.1241 10.09 10.5211 9.19556 9.85648C8.38054 9.25088 7.24362 8.80002 6.00005 8.80002C4.75648 8.80002 3.61955 9.25088 2.80454 9.85648C1.91011 10.5211 1.70005 11.1241 1.70005 11.2667L1.70006 11.2685C1.7045 11.2763 1.71726 11.2959 1.74705 11.3262C1.84112 11.422 2.05307 11.5715 2.457 11.7216C3.26743 12.0226 4.50494 12.2 6.00005 12.2C7.49515 12.2 8.73267 12.0226 9.54309 11.7216C9.94703 11.5715 10.159 11.422 10.253 11.3262C10.2828 11.2959 10.2956 11.2763 10.3 11.2685ZM6.00005 13.6C9.14807 13.6 11.7 12.8683 11.7 11.2667C11.7 9.66507 9.14807 7.40002 6.00005 7.40002C2.85203 7.40002 0.300049 9.66507 0.300049 11.2667C0.300049 12.8683 2.85203 13.6 6.00005 13.6Z"
        fill="#969FA8"
      />
    </svg>
  );
};

export default UserSVG;
